const $inject = ['iataSearchService'];

const lbLocationSelectCtrl = function (iataSearchService) {
  let vm = this;

  const MIN_SEARCH_TEXT_LENGTH = 2;
  const MAX_SEARCH_RESULTS = 10;
  const DEFAULT_PLACEHOLDER = 'Enter a location';

  vm.required = vm.required || false;
  vm.isPublic = !!vm.isPublic;
  vm.placeholder = vm.placeholder || DEFAULT_PLACEHOLDER;
  vm.locations = [];
  vm.showLoader = false;

  vm.refreshLocations = refreshLocations;
  vm.groupBy = groupBy;
  vm.remove = remove;
  vm.select = select;

  if (vm.airportCode) {
    vm.showLoader = true;

    iataSearchService
      .getMetroGrouped(
        {
          maxRows: MAX_SEARCH_RESULTS,
          term: vm.airportCode,
        },
        vm.isPublic
      )
      .then((result) => {
        vm.location = _.find(result, { Value: vm.airportCode });
        vm.showLoader = false;
      });
  }

  function refreshLocations(searchText) {
    if (searchText.length < MIN_SEARCH_TEXT_LENGTH) {
      return false;
    }

    vm.showLoader = true;

    iataSearchService
      .getMetroGrouped(
        {
          maxRows: MAX_SEARCH_RESULTS,
          term: searchText,
        },
        vm.isPublic
      )
      .then((result) => {
        vm.locations = result;
        vm.showLoader = false;
      });
  }

  function groupBy(item) {
    return item.groupedBy;
  }

  function remove() {
    vm.location = null;
    vm.airportCode = '';
  }

  function select(location) {
    vm.airportCode = location.Value;
  }
};

lbLocationSelectCtrl.$inject = $inject;

export default lbLocationSelectCtrl;



// WEBPACK FOOTER //
// ./src/components/lbLocationSelect/lbLocationSelectCtrl.js